import { render } from "./PaymentStatusPage.vue?vue&type=template&id=2c0de4aa&scoped=true"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js"

import "./PaymentStatusPage.vue?vue&type=style&index=0&id=2c0de4aa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0de4aa"]])

export default __exports__